import PropTypes from 'prop-types';
import React from 'react';
import ContentLoader from 'react-content-loader';
import { useMediaQuery } from 'react-responsive';

import { largeUp } from 'constants/mediaQueries';
import Theme from 'styles/theme';

const IMAGE_WIDTH = 675;
const THUMBNAILS_IMAGE_WIDTH = 78;
const HORIZONTAL_GAP = 25;
const VERTICAL_GAP = 7.8; // 7 gaps between 8 thumbnails

const ThumbnailsPlaceholder = ({ slidesCount }) =>
  Array.from({ length: slidesCount }, (_, i) => (
    <rect
      className="thumbnailsPlaceholder"
      key={`thumbnail-${i}`}
      x={0}
      y={i * (THUMBNAILS_IMAGE_WIDTH + VERTICAL_GAP)}
      width={THUMBNAILS_IMAGE_WIDTH}
      height={THUMBNAILS_IMAGE_WIDTH}
    />
  ));

const PdpCarouselPlaceholder = ({ slidesCount, ...props }) => {
  const isLargeUp = useMediaQuery({ query: largeUp });
  return (
    <ContentLoader
      primaryColor={Theme.get('colors-grey')}
      secondaryColor={Theme.get('colors-grey')}
      speed={1}
      height={IMAGE_WIDTH}
      width={isLargeUp ? IMAGE_WIDTH + THUMBNAILS_IMAGE_WIDTH + HORIZONTAL_GAP : IMAGE_WIDTH}
      ariaLabel="Loading product images"
      {...props}
    >
      <rect
        className="imagePlaceholder"
        x={isLargeUp ? THUMBNAILS_IMAGE_WIDTH + HORIZONTAL_GAP : 0}
        y={0}
        width={IMAGE_WIDTH}
        height={IMAGE_WIDTH}
      />
      {isLargeUp && <ThumbnailsPlaceholder slidesCount={slidesCount} />}
    </ContentLoader>
  );
};

ThumbnailsPlaceholder.propTypes = {
  slidesCount: PropTypes.number,
};

PdpCarouselPlaceholder.propTypes = {
  uniquekey: PropTypes.string.isRequired,
  slidesCount: PropTypes.number,
};

PdpCarouselPlaceholder.defaultProps = {
  slidesCount: 8,
};

export default PdpCarouselPlaceholder;
